import { createSlice } from "@reduxjs/toolkit";

export const uiCalcoloMenuSlice = createSlice({
    name: "UI_calcolo_menu",
    initialState: {
        totale: "0 €",      
    },
    reducers: {
        handleTotale: (state, action) => {
            state.totale = action.payload;            
        },       
    }
});

export const {handleTotale} = uiCalcoloMenuSlice.actions;

export default uiCalcoloMenuSlice.reducer;